<template>
  <div class="case-detail-page">
    <!-- 顶部工具栏组件 -->
    <CaseDetailHeader
      :case-number="caseNumber"
      :is-favorited="isFavorited"
      @back="$emit('back')"
      @favoriteChange="$emit('favoriteChange', $event)"
    />

    <!-- 下方左右两分栏 -->
    <div class="two-col-wrap">
      <!-- 左侧详情 -->
      <CaseDetailContent
        ref="contentRef"
        :active-tab="activeTab"
        :analyze-data="analyzeData"
        :menu-list="menuList"
        :active-key="activeKey"
        @tab-change="activeTab = $event"
        @menu-change="handleMenu"
      />
      <!-- 左侧目录 -->
      <CaseDetailright
        :menu-list="menuList"
        :active-key="activeKey"
        @change="handleMenu"
      />
    </div>
  </div>
</template>
<script setup>
import { ref, computed, watch } from "vue";
import CaseDetailHeader from "./CaseDetailHeader.vue";
import CaseDetailContent from "./CaseDetailContent.vue";
import CaseDetailright from "./CaseDetailright.vue";

const props = defineProps({
  analyzeData: Object,
  isFavorited: {
    type: Boolean,
    default: false,
  },
});
defineEmits(["back", "favoriteChange"]);

// 组件ref
const contentRef = ref(null);
// 当前激活tab
const activeTab = ref("origin");

// 当前激活目录
const activeKey = ref("info-person");

// 案号（用于收藏）
const caseNumber = computed(() => {
  const raw = props.analyzeData?.rawResult
    ? JSON.parse(props.analyzeData.rawResult)
    : {};
  return raw["案号"] || props.analyzeData?.caseNumber || "";
});

// 根据 analyzeData 动态构建左侧目录（始终显示完整菜单）
const menuList = computed(() => {
  const list = [
    { key: "info-person", title: "当事人信息" },
    { key: "process", title: "审理经过" },
    // { key: 'trial-org', title: '审判组织' },
  ];

  const isSecond = props.analyzeData?.trialLevel?.includes("二审");

  if (isSecond) {
    const secondMap = [
      { key: "first-claims", title: "一审诉讼请求" },
      // { key: 'first-defense', title: '一审辩称' },
      { key: "first-find", title: "一审认定事实" },
      { key: "first-think", title: "一审本院认为" },
      { key: "first-result", title: "一审判决结果" },
      { key: "second-claims", title: "二审诉讼请求" },
      // { key: 'second-defense', title: '二审辩称' },
      { key: "second-find", title: "二审认定事实" },
      { key: "second-think", title: "二审本院认为" },
      { key: "second-result", title: "二审判决结果" },
    ];
    secondMap.forEach((item) => list.push(item));
  } else {
    const firstMap = [
      { key: "claims", title: "诉讼请求" },
      // { key: 'defense', title: '辩称' },
      { key: "find", title: "认定事实" },
      { key: "think", title: "本院认为" },
      { key: "result", title: "判决结果" },
    ];
    firstMap.forEach((item) => list.push(item));
  }
  return list;
});

// console.log(props.analyzeData,menuList,'analyzeData')
// analyzeData 变化时设置默认 activeKey
watch(
  () => props.analyzeData,
  (val) => {
    if (val && menuList.value.length > 0) {
      activeKey.value = menuList.value[0].key;
    }
  },
  { immediate: false },
);

/**
 * 左侧菜单点击 -> 定位到对应锚点
 */
const handleMenu = (key) => {
  activeKey.value = key;
  const element = document.getElementById(key);
  if (element) {
    element.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
};
</script>
<style scoped lang="less">
.case-detail-page {
  width: 100%;
  height: calc(100vh - 112px);
  display: flex;
  flex-direction: column;
}
.two-col-wrap {
  flex: 1;
  min-height: 0;
  max-height: 88vh;
  display: flex;
  gap: 20px;
}
// 左侧详情占剩余宽度
.two-col-wrap > :first-child {
  flex: 1;
  min-width: 0;
  height: 100%;
}
// 右侧目录固定宽度
.two-col-wrap > :last-child {
  width: 280px;
  flex-shrink: 0;
  height: 100%;
}
</style>
